import React from "react";
import BallIcon from "../../Assets/Icons/ball.png";

const LoaderBox = ({ text = "Učitavanje..." }) => {
  return (
    <div className="loader-box">
      <div className="ball-wrapper">
        <img src={BallIcon} alt="ikonica lopte" />
      </div>
      <p>{text}</p>
    </div>
  );
};

export default LoaderBox;
